import type {
  Market,
  PatchAdminV1StoresStoreIdMarketsIdBody,
  PostAdminV1StoresStoreIdMarketsBody,
  RoundingInput,
} from '@nucleus-commerce/api-client/admin';
import { money } from '@nucleus-commerce/core';

import type { MarketFormInput, MarketFormOutput } from '../schemas/market-form-schema';

/** `to` is a step in minor units of the market currency; the form edits it as money. */
function toRounding(values: MarketFormOutput): RoundingInput {
  const { rounding } = values;
  if (rounding.mode === 'ending') return { mode: 'ending', ending: Number(rounding.ending) };
  return { mode: rounding.mode, to: rounding.to?.amount ?? 1 };
}

export function toMarketCreate(values: MarketFormOutput): PostAdminV1StoresStoreIdMarketsBody {
  return {
    name: values.name,
    countries: values.countries,
    currency: values.currency,
    rounding: toRounding(values),
    status: values.status,
  };
}

export function toMarketUpdate(values: MarketFormOutput): PatchAdminV1StoresStoreIdMarketsIdBody {
  return {
    name: values.name,
    countries: values.countries,
    currency: values.currency,
    rounding: toRounding(values),
    status: values.status,
  };
}

export function emptyMarketForm(currency: string): MarketFormInput {
  return {
    name: '',
    countries: [],
    currency,
    status: 'active',
    rounding: { mode: 'nearest', to: money(1, currency), ending: '' },
  };
}

export function fromMarket(market: Market): MarketFormInput {
  const { rounding } = market;
  return {
    name: market.name,
    countries: market.countries,
    currency: market.currency,
    status: market.status,
    rounding:
      rounding.mode === 'ending'
        ? { mode: 'ending', to: money(1, market.currency), ending: String(rounding.ending) }
        : { mode: rounding.mode, to: money(rounding.to, market.currency), ending: '' },
  };
}
